import {Space} from "antd";
import {useCreateStoreServiceContext} from "../../context/create-service";
import {CreateServiceBasicFormStep} from "../basic-form";
import {CreateServiceCheckoutFormStep} from "../checkout-form";
import {FormWrapper} from "../../../../../components/form-wrapper";
// import {CreateServicePortfolioImagesUploadStep} from "../content-upload";
import {CreateServiceCoverImagesUploadStep} from "../cover-images-upload";
import {CreateServiceFormStepsMobile} from "../create-service-steps";
import {StyledHideStepOnDesktop} from "../../../../../components/offering-form/general/steps/styles";
import {CreateServiceAutomationsStep} from "../automations";
import {DraftResumeBanner} from "../../../../../components/offering-form/general/draft-resume-banner";
import {useDraftResumeBanner} from "../../../../../utils/offering-create-draft";
// import {CreatePortfolioImagesUploadStep} from "../portfolio-images-upload";

export function CreateServiceMultiStepForm() {
  const {
    dispatch,
    wasDraftRestored,
    state: {currentCreateStoreServiceStep},
  } = useCreateStoreServiceContext();
  const {formKey, showBanner, handleStartFresh} = useDraftResumeBanner(
    wasDraftRestored,
    dispatch
  );

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      {showBanner ? <DraftResumeBanner onStartFresh={handleStartFresh} /> : null}
      <StyledHideStepOnDesktop>
        <CreateServiceFormStepsMobile />
      </StyledHideStepOnDesktop>
      <FormWrapper key={formKey}>
        {currentCreateStoreServiceStep === "basicForm" ? (
          <CreateServiceBasicFormStep />
        ) : currentCreateStoreServiceStep === "checkoutForm" ? (
          <CreateServiceCheckoutFormStep />
        ) : currentCreateStoreServiceStep === "coverImagesUpload" ? (
          <CreateServiceCoverImagesUploadStep />
        ) : currentCreateStoreServiceStep === "automations" ? (
          <CreateServiceAutomationsStep />
        ) : null}
      </FormWrapper>
    </Space>
  );
}

// : currentCreateStoreServiceStep === "portfolioImagesUpload" ? (
//           <CreatePortfolioImagesUploadStep />
//         )
